import { useEffect, useState } from "react";
import { Bell, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

const DISMISS_KEY = "mboazick_push_dismissed_at";

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = window.atob(base64);
    return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

/** Invite l'utilisateur connecté à activer les notifications push PWA. */
export default function PushPrompt() {
    const { user } = useAuth();
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (!user || !("serviceWorker" in navigator) || !("PushManager" in window)) return;
        if (Notification.permission !== "default") return;
        const t = localStorage.getItem(DISMISS_KEY);
        if (t && Date.now() - Number(t) < 7 * 24 * 3600 * 1000) return;
        const timer = setTimeout(() => setShow(true), 4000);
        return () => clearTimeout(timer);
    }, [user]);

    const enable = async () => {
        try {
            const perm = await Notification.requestPermission();
            if (perm !== "granted") { dismiss(); return; }
            const reg = await navigator.serviceWorker.ready;
            const { data } = await api.get("/push/vapid-public-key");
            const sub = await reg.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(data.key),
            });
            await api.post("/push/subscribe", { subscription: sub.toJSON() });
            toast.success("🔔 Notifications activées ! Tu seras prévenu des cadeaux et validations.");
            setShow(false);
        } catch (e) {
            toast.error("Impossible d'activer les notifications");
            dismiss();
        }
    };

    const dismiss = () => {
        localStorage.setItem(DISMISS_KEY, String(Date.now()));
        setShow(false);
    };

    if (!show) return null;
    return (
        <div className="fixed top-20 inset-x-0 z-[75] px-3 flex justify-center" data-testid="push-prompt">
            <div className="bg-[#0F0F0F] border border-[#00c0ff]/40 rounded-2xl shadow-xl p-3.5 flex items-center gap-3 max-w-sm w-full">
                <div className="w-9 h-9 rounded-full bg-[#00c0ff]/15 text-[#00c0ff] flex items-center justify-center shrink-0"><Bell className="w-4 h-4" /></div>
                <p className="flex-1 text-xs text-[#C8C8C8]">Sois prévenu quand tu reçois un <strong className="text-[#F4F4F4]">cadeau</strong> ou une <strong className="text-[#F4F4F4]">validation</strong>.</p>
                <button onClick={enable} className="shrink-0 bg-[#00c0ff] text-[#0F0F0F] font-semibold px-3.5 py-1.5 rounded-full text-xs" data-testid="push-enable-btn">Activer</button>
                <button onClick={dismiss} className="shrink-0 p-1 text-[#6E6E6E] hover:text-[#F4F4F4]" data-testid="push-dismiss-btn"><X className="w-3.5 h-3.5" /></button>
            </div>
        </div>
    );
}
